import React, { useMemo } from 'react';
import { Container, Box, BoxProps, Typography } from '@mui/material';
import { getModuleSelectedGroup } from '../../../../components/DeviceManager/navigations/navigationPath';

import { Outlet } from 'react-router-dom';
import { RouterComponentProps, withRouter } from '../../../../util/route-dom';
import GroupCard from '../../../../components/DeviceManager/Group/Overview/GroupsOverview/GroupCard';
import { ButtonBack } from '../../../../theme/components';
import withHandlingErrors, {
  HandlingErrorWrappedProps,
} from '../../../../handlingErrors';
import { PolyglotComponentProps, withPolyglot } from '../../../../i18n';
import { RootState, useAppSelector } from '../../../../redux/store.model';
import { isSCCService } from '../../redux/rights/selectors/roles';
import {
  getGroupByGroupIdInWorkspaceSelector,
  getGroupsByWorkspaceLoadingSelector,
  getGroupSelectedByQueryParamSelector,
} from '../../../../redux/groups/selectors';
import { connect, ConnectedProps } from 'react-redux';
import { getMyWorkspaceSelector } from '../../../../redux/stoerkID/selectors/StoerkId.selectors';
import { CompanyIcon } from '../../theme/icons';
import { theme } from '../../theme/ThemeProviderWithTheme';

interface GroupManagerLayoutProps
  extends ConnectedComponentProps,
    PolyglotComponentProps,
    HandlingErrorWrappedProps,
    RouterComponentProps<{ groupId?: string | undefined }> {}

const MainContainer = (props: { moduleSelected: string } & BoxProps) => {
  const { moduleSelected, children, ...others } = props;

  return (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        height: '100%',
        backgroundColor:
          moduleSelected === 'dashboard'
            ? 'background.default'
            : 'background.paper',
      }}
    >
      {children}
    </Container>
  );
};

const ChildContainer = (props: { moduleSelected: string } & BoxProps) => {
  const { moduleSelected, children, ...others } = props;
  if (moduleSelected === 'dashboard') {
    return (
      <Box {...others} px={{ xs: 1, md: 4 }} py={1}>
        {children}
      </Box>
    );
  }
  return (
    <Container
      maxWidth="lg"
      disableGutters
      sx={{ py: 1, px: { xs: 1, md: 0 } }}
    >
      {children}
    </Container>
  );
};
function FreshwatchGroupManagerLayoutSimple(props: GroupManagerLayoutProps) {
  const { params } = props;
  const { groupId } = params;

  const workspace = useAppSelector(getMyWorkspaceSelector);

  const group = useAppSelector((state: RootState) =>
    getGroupByGroupIdInWorkspaceSelector(state, {
      groupId,
      workspaceId: workspace?.id ?? '',
    })
  );
  const isLoading = useAppSelector((state: RootState) =>
    getGroupsByWorkspaceLoadingSelector(state, {
      workspaceId: workspace?.id ?? '',
    })
  );
  const { pathname } = window.location;
  const polyglot = props.polyglot;
  const isAdmin = useAppSelector(isSCCService);

  const navigate = props.navigate;

  /* Navigation */
  const moduleSelected = useMemo(() => {
    return getModuleSelectedGroup(pathname);
  }, [pathname]);

  return (
    <MainContainer moduleSelected={moduleSelected}>
      {isAdmin && groupId && (
        <GroupCard
          group={
            {
              ...group,
              iconNode: (
                <CompanyIcon
                  style={{
                    color: theme.palette.primary.main,
                    height: '2.5rem',
                  }}
                />
              ),
            } as any
          }
          moduleSelected={moduleSelected}
          groupId={groupId}
          loading={isLoading}
        />
      )}

      {groupId !== undefined && isAdmin && (
        <Box sx={{ mx: { xs: 1, md: 3 } }}>
          <ButtonBack onClick={() => navigate(-1)} sx={{ minWidth: 'auto' }}>
            <Typography variant="body2">{polyglot.t('button.back')}</Typography>
          </ButtonBack>
        </Box>
      )}
      <ChildContainer moduleSelected={moduleSelected}>
        <Outlet />
      </ChildContainer>
    </MainContainer>
  );
}
const mapStateToProps = (
  state: RootState,
  props: RouterComponentProps<{ groupId?: string | undefined }>
) => ({
  group: getGroupSelectedByQueryParamSelector(state, props),
});

const connector = connect(mapStateToProps);
type ConnectedComponentProps = ConnectedProps<typeof connector>;

export default withHandlingErrors(
  withPolyglot(withRouter(connector(FreshwatchGroupManagerLayoutSimple)))
);
